import React from "react";

const blogs = [
  {
    img: "/images/keyword/8.jpg",
    category: "Travel Tips",
    date: "March 10, 2026",
    title: "Pune to Lonavala Cab",
    link: "/Pune-to-Lonavala-Cab",
  },
  {
    img: "/images/keyword/20.jpg",
    category: "Service",
    date: "March 15, 2026",
    title: "Pune to Goa Cab",
    link: "/Pune-to-Goa-Cab",
  },
  {
    img: "/images/keyword/27.jpg",
    category: "Journey",
    date: "March 20, 2026",
    title: "Pune to Kolhapur Cabs",
    link: "/Pune-to-Kolhapur-Cabs",
  },
];

const BlogSection = () => {
  return (
    <section className="blog-section-four bhg">
      <div className="container">
        <div className="section-heading heading-four" data-aos="fade-down">
          <h2>Insights from SRS Cab Service</h2>
          <p>
            Stay updated with tips, guides, and insights to make your rides safer and more enjoyable.
          </p>
        </div>

        <div className="row row-gap-3 justify-content-center">
          {blogs.map((blog, index) => (
            <div className="col-lg-4 col-md-6 d-flex" key={index}>
              <div className="blog-item flex-fill py-5">
                <div className="blog-img">
                  <img src={blog.img} className="img-fluid" alt="blog" />
                </div>

                <div className="blog-content">
                  <h5 className="title titleee text-center">
                    <a className="titleee" href={blog.link}>
                      {blog.title}
                    </a>
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Booking Info Section */}
        <div className="subscribe-sec">
          <div className="row align-items-end">
            <div className="col-md-6">
              <div className="subscribe-content">
                <h2>
                  Book Your Ride with <span>SRS Cab Service</span>
                </h2>

                <p className="text-white">
                  Experience safe, comfortable, and reliable cab services across Pune and nearby cities.
                  Whether it's a short city ride or a long journey, SRS Cabs ensures timely pickups,
                  professional drivers, and a hassle-free travel experience.
                </p>

                <p className="text-white">
                  For bookings, call us or visit our website to plan your next ride effortlessly.
                  Your journey is our priority.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="subscribe-img">
                <img
                  src="/images/mob.png"
                  alt="app"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>

          <img src="/img/bg/app-bg.svg" alt="bg" className="app-bg-01" />
        </div>
      </div>
    </section>
  );
};

export default BlogSection;